const benefits = [
  {
    icon: 'ri-movie-2-line',
    title: 'Mes de streaming gratis',
    desc: 'Al cumplir 4 meses activo sin retrasos, puedes recibir 1 mes gratis en plataformas participantes.',
  },
  {
    icon: 'ri-user-add-line',
    title: 'Beneficios por referidos',
    desc: 'Por cada persona que refieras y active su membresia, puedes recibir beneficios adicionales.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Hasta 2 meses gratis',
    desc: 'Al afiliar 5 socios activos con tu ID Coverly, puedes recibir hasta 2 meses de membresia sin costo.',
  },
  {
    icon: 'ri-coupon-3-line',
    title: 'Descuentos afiliados',
    desc: 'Los miembros activos pueden acceder a descuentos en negocios y servicios con convenio Coverly.',
  },
];

export default function EmotionalImpact() {
  return (
    <section id="beneficios" className="bg-[#F7F6FF] py-14 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex rounded-full border border-[#DDD8F5] bg-white px-4 py-2 text-xs font-black uppercase tracking-wide text-[#534AB7]">
            Coverly Contigo
          </span>
          <h2 className="mt-5 font-title text-3xl font-black leading-tight tracking-[-0.035em] text-[#171421] md:text-5xl">
            Beneficios que suman, sin distraer de lo importante
          </h2>
          <p className="mt-5 text-base leading-8 text-[#625D70] md:text-lg">
            La razon principal para contratar Coverly es organizar a tu familia. Estos beneficios son valor adicional para miembros activos.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-4">
          {benefits.map((benefit) => (
            <article key={benefit.title} className="rounded-[28px] border border-[#E8E4F8] bg-white p-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F1EEFF] text-[#534AB7]">
                <i className={`${benefit.icon} text-xl`} />
              </div>
              <h3 className="mt-5 text-lg font-black text-[#242033]">{benefit.title}</h3>
              <p className="mt-3 text-sm leading-7 text-[#6B6578]">{benefit.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
